module.exports = __webpack_public_path__ + "static/img/wyfwlogo.f625c99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wyfwlogo.png
// module id = Mtv+
// module chunks = 1